//Please add the language resource
const truck = {
  truckCode: 'truckCode',
  sinoiovNetworkJoinStatus: '是否中交入网',
  plateColor: 'plateColor',
  truckType: 'truckType',
  companyCode: 'companyCode',
  companyName: 'companyName',
  carrierCode: 'carrierCode',
  carrierName: 'carrierName',
  loadWeight: 'loadWeight',
  loadVolume: 'loadVolume',
  remark: 'remark',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
  useCompanyName: 'useCompanyName',
  gpsFlag: 'gpsFlag',
  activeOff: 'activeOff',
};
export default truck



// WEBPACK FOOTER //
// ./src/page/mdm/truck/lang/truck.en.js